jQuery(function($){
  $(document).ready(function(){
    
    function basketball_mobile(){
      if($(window).width() <= 700 ){
        $('.single-product .product-title').prependTo('.single-product .grid');
        $('.single-product .price').insertAfter('.single-product .product-title');

      }else{
        $('.single-product .product-title').prependTo('.single-product .shopify-product-form');
        $('.single-product .price').insertAfter('.single-product .product-title');
      }
    }
    
    basketball_mobile();
    
    $(window).resize(function(){
    	basketball_mobile();
    });
    
    
    //tabs
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
    
    
    //read more
    $('.fade_box button').click(function(){
      	
      if($('.product-tabs').hasClass('expand')){
      	$('.product-tabs').removeClass('expand');
        $(this).siblings('.fade').removeClass('hide');
      	$(this).text('Read more');
      }else{
      	$('.product-tabs').addClass('expand');
        $(this).siblings('.fade').addClass('hide');
      	$(this).text('Read less');
      }
    });
    
    
    //footer
    $('footer.site-footer .grid .box:not(:first-child) h4').click(function(){
    	$(this).siblings('ul').toggleClass('show');
      	$(this).toggleClass('rotate-after');
      	$('footer.site-footer .grid .box.social p').toggleClass('show');
    })
 	
    
  })
});